import { useContext, useEffect, useMemo, useState } from "react";
import { GenerateContext } from "@view/page_v3/hooks/GenerateContext";
import styles from "./index.module.scss";

const CARD_DATA = [
    {
        id: 1,
        image: "sample1.png",
        hoverImage: "sample1_hover.png",
        sampleImage: ["sample1_1.png", "sample1_2.png"],
        text: "将图1的背心和短裤，还有外套穿在图2的模特身上，外套比较轻薄透视，保持原来的姿势不变，一侧外套耷拉下来落在手肘处，露出肩膀皮肤",
    },
    {
        id: 2,
        image: "sample2.png",
        hoverImage: "sample2_hover.png",
        sampleImage: ["sample2_1.png", "sample2_2.png"],
        text: "将图1的人脸换到图2上，复刻图1模特的妆容，包括：眼线、睫毛、眉毛、唇色，保持图2的构图不变",
    },
    {
        id: 3,
        image: "sample3.png",
        hoverImage: "sample3_hover.png",
        sampleImage: ["sample3_1.png"],
        text: "将图片中的女生的动作改成：一只手比耶，手臂向外抬起并弯曲，放在眼侧；另一只手叉腰，手掌贴在腰侧，手指自然张开，拇指在后，手肘向外打开；身体扭转：上半身微微向右侧扭转，腰部轻轻向左侧顶出，胸部向前微微挺；表情：微笑，眼神看向侧前方，露出更多眼白，整体动作俏皮可爱",
    },
    {
        id: 4,
        image: "sample4.png",
        hoverImage: "sample4_hover.png",
        sampleImage: ["sample4_1.png"],
        text: "给图片中的果味气泡饮料换个背景，使其更具商业价值。瓶子居中并立在木质桌面上桌子上，还有些小贝壳和水果（百香果、橙子、树莓、蓝莓等）点缀，氛围感强一点，在热带海滩，有棕榈树，沙滩，瓶身上还有水珠",
    },
];

const ExampleCards = () => {
    const { setPrompt, setMatchImages } = useContext(GenerateContext);
    const [hoveredId, setHoveredId] = useState(null);
    const [typedCount, setTypedCount] = useState(0);
    const [isTyping, setIsTyping] = useState(false);
    const sampleImageBaseUrl = "https://photostudio-ai-oss.arcsoft.com.cn/photostudio-web/admin/creative-to-image/createSample/";

    const hoveredCard = useMemo(() => {
        return CARD_DATA.find((item) => item.id === hoveredId);
    }, [hoveredId]);

    useEffect(() => {
        if (!hoveredCard) {
            setTypedCount(0);
            setIsTyping(false);
            return undefined;
        }

        setTypedCount(0);
        setIsTyping(true);

        const timer = setInterval(() => {
            setTypedCount((prev) => {
                const next = prev + 1;
                if (next >= hoveredCard.text.length) {
                    clearInterval(timer);
                    setIsTyping(false);
                    return hoveredCard.text.length;
                }
                return next;
            });
        }, 100);

        return () => clearInterval(timer);
    }, [hoveredCard]);

    const handleCardClick = (item) => {
        setPrompt(item.text || "");
        setMatchImages((item.sampleImage || []).map((name) => ({ url: `${sampleImageBaseUrl}${name}` })));
    };

    return (
        <div className={styles.ExampleCards}>
            {CARD_DATA.map((item) => (
                <div
                    className={styles.Card}
                    key={item.id}
                    style={{
                        backgroundImage: `url(https://photostudio-ai-oss.arcsoft.com.cn/photostudio-web/admin/creative-to-image/${hoveredId === item.id ? item.hoverImage : item.image})`,
                    }}
                    onClick={() => handleCardClick(item)}
                    onMouseEnter={() => setHoveredId(item.id)}
                    onMouseLeave={() => setHoveredId(null)}
                >
                    {hoveredId === item.id && (
                        <p className={styles.CardText}>
                            {item.text.slice(0, typedCount)}
                            {isTyping ? "_" : ""}
                        </p>
                    )}
                </div>
            ))}
        </div>
    );
};

export default ExampleCards;
